<template>
  <div class="loading">
    <div class="dotl">

    </div>
    <div class="dotr">

    </div>
    <div class="logo">
      <div class="blue"></div>
      <div class="gray"></div>
    </div>
<!--    <p>{{num}}%</p>-->
  </div>
</template>

<script>
export default {
  name:'loading',
  data(){
    return{
      // num:0,
    }
  },
  mounted() {
    setTimeout(()=>{
      const  link='./home.html'
      window.open(link,'_self')
    },800)
  }
};
</script>

<style scoped>
.loading{
  position: relative;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  background: url("../assets/aem/loadBg.png") no-repeat;
  background-size: cover;
}
.loading::before{
  content:'';
  display: inline-block;
  width:40%;
  position: absolute;
  left:0;
  top:50%;
  height:1px;
  background:#00748D;
  opacity:0.1;
}
.loading::after{
  content:'';
  display: inline-block;
  width:40%;
  position: absolute;
  right:0;
  top:50%;
  height:1px;
  background:#00748D;
  opacity:0.1;
}
.loading .logo{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 225px;
  height:56px;
  overflow: hidden;
  z-index: 100;
}
.dotl{
  position: absolute;
  left:40%;
  width: 6px;
  height: 6px;
  background: #00748D;
  border-radius: 50%;
  top:49.7%;
}
.dotr{
  position: absolute;
  right:40%;
  width: 6px;
  height: 6px;
  background: #00748D;
  border-radius: 50%;
  top:49.7%;
}
.loading .blue{
  position: absolute;
  top: 0;
  left: 0;
  width: 225px;
  height:56px;
  background: url('../assets/aem/wlogo.png')no-repeat left;
  z-index: 3;
  animation: logo 1500ms infinite cubic-bezier(0.96,-0.09, 0.29, 1.31);
}
.loading .gray{
  position: absolute;
  top: 0;
  left: 0;
  width: 225px;
  height:56px;
  background: url('../assets/aem/blogo.png')no-repeat left;
  z-index: 2;
  animation: logo2 1500ms infinite cubic-bezier(0.96,-0.09, 0.29, 1.31);
}

@keyframes logo2 {
  0% {
    transform:translateY(0);
    opacity: 1;
  }
  100% {
    transform:translateY(60px);
    opacity: 0;
  }
}

@keyframes logo {
  0% {
    transform:translateY(-60px);
    opacity: 0;
  }
  100% {
    transform:translateY(0);
    opacity: 1;
  }
}

@media screen and (max-width: 1000px){
  .loading::before{
    display: none;
  }
  .loading::after{
    display: none;
  }
  .dotl,.dotr{
    display: none;
  }
}
</style>


